import { ImageOptionsTypes } from '@/components/atoms/Image/types'
import { applyFilters } from './helpers'

function buildImageUrl(originalPath: string, image: ImageOptionsTypes) {
  const { width, height, smartCrop, quality, format, fill } = image
  const [, , , extension] = originalPath.split('.')
  let url = `${originalPath}/m/`

  if (width && height) {
    url += `${width}x${height}`
  }

  if (smartCrop) {
    url += `/smart`
  }

  let filters = [
    ...[quality && `quality(${quality})`],
    ...[format && format !== extension && `format(${format})`],
    ...[fill && `fill(${fill})`]
  ]

  // remove falsy elements
  filters = filters.filter((element) => Boolean(element))

  if (filters.length > 0) {
    url += applyFilters(filters)
  }

  return url
}

export default buildImageUrl
